var defaultOptions = {};
export function getDefaultOptions() {
  return defaultOptions;
}
export function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/_lib/defaultOptions/index.js
// module id = ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
// module chunks = 1